var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.2502 31.725V37.35C41.2523 37.8722 41.1453 38.3891 40.9361 38.8675C40.7269 39.346 40.4201 39.7755 40.0353 40.1285C39.6505 40.4815 39.1963 40.7503 38.7016 40.9176C38.2069 41.0849 37.6828 41.147 37.1627 41.1C31.393 40.4731 25.8508 38.5015 20.9814 35.3438C16.4511 32.465 12.6102 28.6241 9.73143 24.0938C6.56264 19.2023 4.59064 13.6331 3.97518 7.8375C3.92832 7.319 3.98995 6.79642 4.15612 6.30304C4.32229 5.80966 4.58938 5.35629 4.94037 4.97179C5.29136 4.58729 5.71856 4.28008 6.19479 4.06973C6.67101 3.85938 7.18582 3.75049 7.70643 3.75H13.3314C14.2414 3.74104 15.1235 4.06327 15.8135 4.65662C16.5034 5.24997 16.9541 6.07396 17.0814 6.975C17.3188 8.77512 17.7591 10.5426 18.3939 12.2437C18.6462 12.9149 18.7008 13.6442 18.5513 14.3454C18.4017 15.0466 18.0543 15.6902 17.5502 16.2L15.1689 18.5812C17.8381 23.2754 21.7248 27.1621 26.4189 29.8312L28.8002 27.45C29.31 26.9459 29.9536 26.5985 30.6548 26.4489C31.356 26.2994 32.0853 26.354 32.7564 26.6062C34.4576 27.241 36.2251 27.6813 38.0252 27.9187C38.936 28.0472 39.7678 28.506 40.3624 29.2078C40.9571 29.9096 41.273 30.8055 41.2502 31.725Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.3438 3.75C30.1655 4.15269 33.7353 5.84775 36.4629 8.55484C39.1904 11.2619 40.9123 14.8189 41.3437 18.6375",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.3438 11.25C28.1878 11.6136 29.88 12.5232 31.2007 13.8606C32.5214 15.198 33.4096 16.9015 33.75 18.75",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.bce04621089643a42a1d5a50348dec4c.svg";
export { ForwardRef as ReactComponent };